import type { TOptions, TPlayer } from 'video.js'

import './plugin'

export type { PlaybackHeadersPlugin } from './plugin'

export function configure(options: TOptions): TOptions {
  return options
}

export function inject(player: TPlayer): TPlayer {
  player.playbackHeaders()
  return player
}
